/**
 * SearchBar Component - Uses shadcn/ui Input
 */
import { memo } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const SearchBar = memo(({
  value,
  onChange,
  placeholder = "Search...",
  className = ""
}: SearchBarProps) => {
  return (
    <div className={cn("relative", className)}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground pointer-events-none" />
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-10 bg-muted/60 border-border hover:bg-muted focus:bg-card transition-colors"
      />
    </div>
  );
});

SearchBar.displayName = 'SearchBar';

export default SearchBar;
